// extracted by mini-css-extract-plugin
module.exports = {"meta":"ChatWindow_meta__sY_eO","metaItem":"ChatWindow_metaItem__3N_GJ"};